import React, { useContext } from 'react';
import Config from '../../components/admin/Config';
import Navbar from '../../components/navbar/Navbar';
import Sidebar from '../../components/sidebar/Sidebar';
import "./user.scss";
import { useSidebarState } from '../../components/sidebar/SidebarStateContext';

const ProfileContainer = () => {
  const { collapsed } = useSidebarState();

  return (
    <div className={`user ${collapsed ? 'collapsed' : ''}`}>
      <Sidebar />
      <div className={`userContainer ${collapsed ? 'collapsed' : ''}`}>
        <Navbar />
        <Config />
      </div>
    </div>
  );
};

export default ProfileContainer;
